import { Action } from '@ngrx/store';
import { IrisApplicationI } from '@iris/common/models/IrisApplication';

export enum IrisApplicationsActionsTypes {
  LoadApplications = '[Applications] LoadApplications',
  LoadApplicationsComplete = '[Applications] LoadApplicationsComplete',
  SetAppAlias = '[Applications] Set App Alias',
  SetApplication = '[Applications] Set application',
  SetApplicationComplete = '[Applications] Set application complete',
}

export class LoadApplications implements Action {
  readonly type = IrisApplicationsActionsTypes.LoadApplications;
}

export class LoadApplicationsComplete implements Action {
  readonly type = IrisApplicationsActionsTypes.LoadApplicationsComplete;

  constructor(public payload: IrisApplicationI[]) { }
}

export class SetAppAlias implements Action {
  readonly type = IrisApplicationsActionsTypes.SetAppAlias;
  constructor(public payload: string) {}
}

export class SetApplication implements Action {
  readonly type = IrisApplicationsActionsTypes.SetApplication;
  constructor(public payload: string) {}
}

export class SetApplicationComplete implements Action {
  readonly type = IrisApplicationsActionsTypes.SetApplicationComplete;
  constructor(public payload: IrisApplicationI) {}
}

export type IrisApplicationsActions = LoadApplications | LoadApplicationsComplete | SetAppAlias | SetApplication | SetApplicationComplete;
